import { render } from "./UpgradePrompt.vue?vue&type=template&id=ef271776&scoped=true"
import script from "./UpgradePrompt.vue?vue&type=script&lang=js"
export * from "./UpgradePrompt.vue?vue&type=script&lang=js"

import "./UpgradePrompt.vue?vue&type=style&index=0&id=ef271776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef271776"]])

export default __exports__